export default (value) => value == null || value.trim() === ''
